import React, { FC, memo, useCallback, useState } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { UserBalanceModal } from './UserBalanceModal';
import { ReactComponent as InfoIcon } from 'shared/assets/icons/InfoIcon.svg';
import { Tooltip } from 'shared/ui/Tooltip';

interface UserBalanceHistoryProps {
  userId: string;
  balance: number;
}

export const UserBalanceHistory: FC<UserBalanceHistoryProps> = memo((props) => {
  const { userId, balance } = props;

  const { t } = useAppTranslation('profile');

  const [openedUserBalanceHistoryModal, setOpenedUserBalanceHistoryModal] = useState(false);

  const openBalanceHistoryModal = useCallback(() => {
    setOpenedUserBalanceHistoryModal(true);
  }, []);

  const closeBalanceHistoryModal = useCallback(() => {
    setOpenedUserBalanceHistoryModal(false);
  }, []);

  return (
    <div>
      <Tooltip title={t('Click to show balance history')}>
        <InfoIcon
          width={25}
          height={25}
          className="[&>path]:stroke-accent cursor-pointer flex-shrink-0 mb-1"
          onClick={openBalanceHistoryModal}
        />
      </Tooltip>
      <UserBalanceModal userId={userId} isOpened={openedUserBalanceHistoryModal} onClose={closeBalanceHistoryModal} balance={balance} />
    </div>
  );
});
